// src/mixins/authMixin.js
import axios from 'axios';
export default {
    methods: {
        async checkToken($http, $router, redirectRoute = null) {
            const accessToken = localStorage.getItem('authToken');

            if (!accessToken) {
                this.redirectToLogin();
                return;
            }

            try {
                const response = await $http.post('/auth/check', {
                    accessToken: accessToken,
                })

                if (response.status === 200) {
                    console.log('redirect', redirectRoute)
                } else {
                    this.redirectToLogin($router);
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du token :', error);
                this.redirectToLogin($router);
            }
        },
        redirectToLogin($router) {
            localStorage.removeItem('authToken');
            $router.push({ name: 'Login' });
        },
    },
};
